import { use, graphic } from "echarts/core";
import { CanvasRenderer, SVGRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import {
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  BrushComponent,
} from "echarts/components";
import moment from "moment";

use([
  CanvasRenderer,
  SVGRenderer,
  LineChart,
  BarChart,
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  BrushComponent,
]);

export default {
  data() {
    return {
      chart_line: [],
      sorted: { negative: [], positive: [] },
    };
  },
  methods: {
    InsertZeros(sourceArray, datesArray) {
      if (sourceArray.length > 1) {
        for (var i = 0; i < sourceArray.length; i++) {
          // if (i == 0) {
          //   datesArray.splice(0, 0, datesArray[0]);
          // }
          //
          if (sourceArray[i] < 0 && sourceArray[i + 1] > 0) {
            sourceArray.splice(i + 1, 0, 0);
            datesArray.splice(i + 1, 0, datesArray[i]);
          } else if (sourceArray[i] > 0 && sourceArray[i + 1] < 0) {
            sourceArray.splice(i + 1, 0, 0);
            datesArray.splice(i + 1, 0, datesArray[i]);
          }
        }
      }
      return [sourceArray, datesArray];
    },
    GetPositiveData(sourceArray) {
      let data_copy = sourceArray;
      for (var i = 0; i < data_copy.length; i++) {
        if (data_copy[i] < 0) {
          data_copy[i] = null;
          // this.$set(data_copy, i, null);
        }
      }
      return data_copy;
    },
    //
    GetNegativeData(sourceArray) {
      let data_copy = sourceArray;
      for (var i = 0; i < data_copy.length; i++) {
        if (data_copy[i] > 0) {
          data_copy[i] = null;
          // this.$set(data_copy, i, null);
        }
      }
      return data_copy;
    },
    chartLine(value) {
      let list_date = [];
      let values = [];
      let grid = {};

      let dark =
        this.ui_theme == "DARK"
          ? this.config.theme_chart.dark
          : this.config.theme_chart.light;

      value.forEach((item) => {
        list_date.push(item.equity_time);
        values.push(item.equity_value);
      });

      list_date = list_date.sort();

      let value_date = JSON.parse(
        JSON.stringify(this.InsertZeros(values, list_date)[1])
      );
      let value_up = JSON.parse(
        JSON.stringify(this.InsertZeros(values, list_date)[0])
      );
      let value_dn = JSON.parse(
        JSON.stringify(this.InsertZeros(values, list_date)[0])
      );

      let pos_data = this.GetPositiveData(value_up);
      let neg_data = this.GetNegativeData(value_dn);

      if (this.$screen.portrait) {
        grid = {
          left: "6%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        };
      } else {
        grid = {
          left: "5%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        };
      }

      let option = {
        dataZoom: [{ type: "inside", filterMode: "filter", minSpan: 40 }],

        grid: grid,

        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        tooltip: {
          show: false,
        },
        xAxis: [
          {
            data: value_date,
            type: "category",
            boundaryGap: false,

            axisLine: {
              lineStyle: { color: dark.line },
            },

            axisLabel: {
              formatter: function (value) {
                let new_date = "";
                new_date = moment(value).format("L");
                return new_date;
              },
              color: dark.font_color,
              fontSize: 10,
              fontFamily: "Poppins",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          type: "value",
          scale: true,

          nameTextStyle: {
            fontSize: 10,
            show: false,
          },
          axisLabel: {
            color: dark.font_color,
            fontSize: 10,
            fontFamily: "Poppins",
            formatter: function (value) {
              value = value.toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
              });
              return value;
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: dark.line,
            },
            show: true,
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "Negative",
            type: "line",
            symbol: "circle",
            symbolSize: 0,
            // sampling: "average",
            data: neg_data,

            itemStyle: {
              color: "#e74c3c",
            },

            areaStyle: {
              color: new graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(235, 77, 75, 0.5)",
                },
                {
                  offset: 1,
                  color: dark.chart_2,
                },
              ]),
            },
            animationDelay: function (idx) {
              return idx * 2000;
            },
          },

          {
            name: "Positive",
            type: "line",
            symbol: "circle",
            symbolSize: 0,
            data: pos_data,

            itemStyle: {
              color: "#19D684",
            },

            areaStyle: {
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(25, 214, 132, 0.5)",
                },
                {
                  offset: 1,
                  color: dark.chart_2,
                },
              ]),
            },
            animationDelay: function (idx) {
              return idx * 2000;
            },
          },
        ],
        animationEasing: "elasticOut",
        animationDelayUpdate: function (idx) {
          return idx * 5;
        },
      };

      this.chart_line = option;
    },
  },
};
